var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.916 15.3801C21.947 13.2432 23.24 11.2212 25.2912 10.102C23.9972 8.46167 21.8298 7.42168 19.5749 7.35906C17.1698 7.135 14.8382 8.63643 13.6126 8.63643C12.3633 8.63643 10.4763 7.38131 8.44433 7.41842C5.79575 7.49437 3.32661 8.83091 2.03802 10.8861C-0.731941 15.1427 1.3342 21.3985 3.98759 24.8392C5.31513 26.524 6.86666 28.406 8.89679 28.3392C10.8834 28.2661 11.6254 27.2149 14.0234 27.2149C16.3991 27.2149 17.0952 28.3392 19.1665 28.2968C21.2983 28.2661 22.6414 26.6045 23.9223 24.9037C24.8762 23.7032 25.6101 22.3764 26.0971 20.9725C23.5919 20.032 21.9189 17.7944 21.916 15.3801Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0036 5.09629C19.1659 3.85785 19.7385 2.26606 19.5999 0.658936C17.8241 0.824475 16.1838 1.57775 15.0058 2.76867C13.8539 3.93226 13.2544 5.49605 13.3678 7.04174C15.1441 7.05798 16.8905 6.32512 18.0036 5.09629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/Apple_logo.ca1954d1b7a404ba1357136f91442a80.svg";
export { ForwardRef as ReactComponent };